import { IsOptional, MaxLength, MinLength } from "class-validator";
import { PaginationModel } from "@/shared/models/PaginatorModel.ts";

export class AcquisitionModalityModel {
  @IsOptional()
  public id: number | string;

  @MinLength(3, { message: "min_acquisition_name" })
  @MaxLength(80, { message: "max_acquisition_name" })
  public name: string;

  @MinLength(2, { message: "min_acquisition_acronym" })
  @MaxLength(6, { message: "max_acquisition_acronym" })
  public acronym: string;

  constructor(data: Partial<AcquisitionModalityModel> = {}) {
    this.id = data.id ?? 0;
    this.name = data.name ?? "";
    this.acronym = data.acronym ?? "";
  }
}

export class AcquisitionModalitiesPaginatedModel extends PaginationModel {
  constructor(data: Partial<PaginationModel> = {}) {
    data.content = Array.isArray(data.content)
      ? data.content?.map((item: AcquisitionModalityModel) => new AcquisitionModalityModel(item))
      : [];

    super(
      data.content,
      data.pageable,
      data.totalElements,
      data.totalPages,
      data.last,
      data.size,
      data.number,
      data.sort,
      data.first,
      data.numberOfElements,
      data.empty,
    );
  }
}
